module.exports = __webpack_public_path__ + "static/media/LightLanguage.b33946a3.webp";